import { Component, Input, Output, EventEmitter} from '@angular/core'

@Component({
  selector: 'app-st-chip-list',
  templateUrl: './st-chip-list.component.html',
  styleUrls: ['./st-chip-list.component.scss'],
  standalone: false
})
export class StChipListComponent {

  @Input()
  idVal: string = 'chipListId';

  @Input()
  chipList: string[] = [];

  @Input()
  backgroundColor: string = '#ffffff';

  @Input()
  fontColor: string = '#000000'

  @Output()
  onClick = new EventEmitter<Event>();

  onClickEvent(row: string): void {
    const eventOut = new Event(String(row));
    console.log('row: ' + row);

    //copy the list and remove the desire element
    let newlist: string[] = []
    console.log('this.chipList: ' + this.chipList);
    let i: number = 0;
    while(i < this.chipList.length) {
      console.log('this.chipList: ' + this.chipList[i]);
      if (row != this.chipList[i]) {
        newlist.push(this.chipList[i]);
      }
      i = i + 1;
    }
    this.chipList = newlist;
    this.onClick.emit(eventOut);
  }

  protected readonly Event = Event;
}
